import Utils from 'common/utils'
import UrlManager from 'manager/urlManager'
import Network from 'common/network'
import Constants from 'common/constants'
import Analytics from 'analytics'
import CacheStore from 'stores/cacheStore'


const US_COUNTRY_STR = "United States"

export default class WeatherDataSource {
    static fetchCurrentGeoData(responseHandler) {
        var timeout = 7000;
        Network.fetchWithTimeoutAndRetry(UrlManager.getIpGeoEndpoint(), timeout, 4)
            .then((response) => {
                if (false === response.ok) {
                    throw Error(response.statusText)
                }
                return response.json()
            })
            .then((resp) => {
                responseHandler(resp["geo"], null)
            })
            .catch((e) => {
                responseHandler(null, e)
            })
    }


    // Method to make an api request and fetch the corresponding data
    static fetchWeatherDataForLocation(lat, long, responseHandler, shouldSaveToCacheStore = false) {
        Analytics.sendEvent(
            Constants.ANALYTICS.EVENTS.CATEGORY.DATA,
            Constants.ANALYTICS.EVENTS.ACTION.FETCH_START,
            null,
            null,
            true,
        )

        // Make an actual api request here
        var params = {
            "latitude": lat,
            "longitude": long
        }

        var queryString = Object.keys(params).map(function (key) {
            return key + '=' + params[key]
        }).join('&');
        var weatherUrl = UrlManager.getWeatherEndpoint() + "?" + queryString;
        var timeout = 30000; // 30 secs

        // Replace that with the weather timeout
        Network.fetchWithTimeout(weatherUrl, timeout)
            .then(function (response) {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response.json();
            }).then(function (response) {
                console.log("Final response")
                console.log(response)

                Analytics.sendEvent(
                    Constants.ANALYTICS.EVENTS.CATEGORY.DATA,
                    Constants.ANALYTICS.EVENTS.ACTION.FETCH_SUCCESS,
                    null,
                    null,
                    true,
                )
                if (shouldSaveToCacheStore) {
                    WeatherDataSource.saveWeatherDataToCacheStore(params, response);
                }
                if (false === Utils.isNull(responseHandler)) {
                    responseHandler(response, null)
                }

            }).catch(function (error) {
                console.log(error)
                console.log("Got error from server!")

                Analytics.sendEvent(
                    Constants.ANALYTICS.EVENTS.CATEGORY.DATA,
                    Constants.ANALYTICS.EVENTS.ACTION.FETCH_FAIL,
                    null,
                    null,
                    true,
                )
                if (false === Utils.isNull(responseHandler)) {
                    responseHandler(null, error)
                }

            })
    }

    static saveWeatherDataToCacheStore(params, response) {
        if (false === Utils.isNull(response)) {
            var reqHash = Utils.getLatLonHash(params['latitude'], params['longitude'])
            var cacheIp = {
                response: response,
            }
            CacheStore.set(reqHash, cacheIp)
        }
    }

    static fetchAreaFromZipCodeForCountry(zipCode, country, responseHandler) {
        if (Utils.isNull(zipCode) || Utils.isNull(country) || Utils.isNull(responseHandler)) {
            console.log("AREA: Cannot process fetchAreaFromZipCodeForCountry without all three params")
            return
        }
        if (country.toLowerCase() !== US_COUNTRY_STR.toLowerCase()) {
            console.log("AREA: Country has to be ", US_COUNTRY_STR, " got - ", country)
            responseHandler(null, new Error("Country has to be " + US_COUNTRY_STR))
            return
        }

        var url = UrlManager.getZipCodeToCityEndpoint() + "?postal_code=" + zipCode;
        console.log("AREA: Making a request to - ", url)
        Network.fetchWithTimeout(url)
            .then(function (response) {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response.json();
            }).then(function (json) {
                responseHandler(json, null)
            }).catch(function (error) {
                responseHandler(null, error)
            })
    }
}


// WEBPACK FOOTER //
// ./src/dataSource/weatherDataSource.js